import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      color: palette.internal.main,
    },
  },
];

export default variants;
